import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface IFilters {
  applied: [];
  list: [];
}

export interface IResults extends EntityState<any> {
  error: object;
  loading: boolean;
  filters: IFilters;
  hotels: [];
  pagination: {};
  viewMap: boolean;
  locationData: {
    locations: any[];
    poi: any;
  };
  customBanner: any;
  recommendedHotels: {
    hotels: [];
    reference: string;
  };
  destination: any;
}

export const adapter: EntityAdapter<IResults> = createEntityAdapter<IResults>();
export const initialState: IResults = adapter.getInitialState({
  customBanner: null,
  destination: null,
  error: null,
  filters: {
    applied: null,
    list: null,
  },
  hotels: null,
  loading: false,
  locationData: {
    locations: null,
    poi: null,
  },
  pagination: null,
  poiOfPois: null,
  recommendedHotels: {
    hotels: [],
    reference: null,
  },
  viewMap: false,
});
